// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".provider-detail .provider-description a:hover{color:var(--primary-color)}h2{color:var(--secondary-color);font-size:26px;margin-top:24px;margin-bottom:8px}", ""]);
// Exports
module.exports = exports;
